<template lang="html">

</template>

<script>
// Is this been used?
const apiURL = decodeURIComponent(siteGlobals.baseUrl) + "/wp-json/cabbi/v1/";

import { REST } from "./Rest.js";
import Bus from "./Bus.js";
import getUrlParameter from "../helpers/queryString.js";
import resultsSummary from "./mixins/resultsSummary.js";

export default {
  name: "search-grid",
  props: {
    postType: {
      type: String
    },
    searchTerms: {
      type: Array,
      default: function() {
        return [];
      }
    },
    defaultOrder: {
      type: String,
      required: true
    },
    perPage: {
      type: Number,
      default: 9
    }
  },

  mixins: [resultsSummary],

  data: function() {
    return {
      loading: true,
      posts: null,
      page: 1,
      offset: 0,
      totalPosts: null,
      totalPages: null,
      currentSearch: {},
      orderKey: Math.ceil(Math.random() * 100),
      order: this.defaultOrder
    };
  },

  mounted: function() {
    let vm = this;

    Bus.$on("search-submit", function(data) {
      vm.buildResultsSummary(data);
      vm.getPosts(vm.prepareDataForSearch(data));
    });

    Bus.$on("option-deselect", function(option, category) {
      vm.modifySearch();
    });
  },

  watch: {
    order: function() {
      this.modifySearch(true);
    }
  },

  methods: {
    viewProfile: function() {
      ga("send", "event", "View Profile", "Clicks");
    },
    /*
      When a tag is deselected, remove the tag from the results summary
      TODO make naming consistent for arguments passed to "option-deselect" event
    */
    deselect: function(tag, i) {
      this.resultsSummary.splice(i, 1);
      Bus.$emit("option-deselect", tag, tag.type);
    },

    prepareDataForSearch: function(data) {
      let formattedData = {};

      for (let d in data) {
        if (typeof data[d] == "object") {
          // formattedData[d] = data[d].join(",");
          let slugs = data[d].map(obj => {
            return obj.slug;
          });
          formattedData[d] = slugs.join(",");
        } else {
          formattedData[d] = data[d];
        }
      }
      return formattedData;
    },

    /*
      Main function for retrieving entries to display in the grid
    */
    getPosts: function(options = {}) {
      let vm = this;
      vm.loading = true;

      let params = Object.assign(
        {
          // offset: vm.offset,
          page: vm.page,
          per_page: vm.perPage,
          order: vm.order,
          order_key: vm.orderKey
        },
        options
      );

      REST.get(vm.postType + "/", {
        params: params
      })
        .then(function(response) {
          vm.currentSearch = params;
          vm.orderKey = Math.ceil(Math.random() * 100);
          vm.posts = response.data;
          vm.currentSearch.page++;
          vm.totalPosts = response.headers["x-wp-total"];
          vm.totalPages = response.headers["x-wp-totalpages"];
          vm.loading = false;

          //show / hide filter controls based on whether any parameters are being searched
          //time constraints on task have not allowed for refactoring better for vue atm

          let searchItems = [];
          // let searchTerms = ['regions','amenities','inns', 'recipe-categories', 'specials-types'];
          let showFilterControls = false;

          //push all props from search object into array
          for (let searchItem in vm.currentSearch) {
            searchItems.push(searchItem);
          }
          //loop through props and see if any match up with the search tags
          searchItems.forEach(function(element) {
            if (
              element == "regions" ||
              element == "amenities" ||
              element == "inns" ||
              element == "recipe-categories" ||
              element == "specials-types"
            ) {
              //make sure existing properties arnt empty
              if (vm.currentSearch[element] != "") {
                showFilterControls = true;
              }
            }
          });
          //if search params exist show the filter controls
          if (showFilterControls) {
            $(".filter-control").addClass("show");
          } else {
            $(".filter-control").removeClass("show");
          }
        })

        .catch(function(errors) {
          console.log(errors);
          vm.posts = [];
          vm.totalPosts = 0;
          vm.totalPages = 0;
          vm.loading = false;
        });
    },

    /*
      Supplementary function for appending items onto the grid
    */
    appendPosts: function() {
      let vm = this;
      REST.get(vm.postType + "/", {
        params: vm.currentSearch
      })
        .then(function(response) {
          vm.posts = vm.posts.concat(response.data);
          vm.currentSearch.page++;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="css">
</style>
